<span>
  <cap-kompakt-beleg
    [capHistinfo]="histInfo"
    [enableNavigation]="isGeschaeftsmodulCapWebErweiterung"
    [id]="rechtsgrund.rechtsgrundZusatz"
    [item]="rechtsgrund.beleg"
    [referenzObjectId]="rechtsgrund?.rechtsgrundId?.id"
    [referenzObjectType]="'RECHTSGRUND'"></cap-kompakt-beleg>
  <cap-read-more [histInfo]="histInfo" [limit]="textLimit" [text]="text"> </cap-read-more>
</span>
@if (!ohneLoeschgeschaeft) {
  <cap-kompakt-timepoint [item]="rechtsgrund.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
}
